import { Button as TremorButton } from '@tremor/react';
import { ComponentProps, ReactNode } from 'react';
import { Tooltip } from 'radix-ui';
import { TooltipContentProps } from '@radix-ui/react-tooltip';

interface Props extends ComponentProps<typeof TremorButton> {
  tooltip?: ReactNode;
  testId?: string;
  side?: TooltipContentProps['side'];
}

function Button({ tooltip, testId = 'button', side, ...rest }: Props) {
  const buttonElement = <TremorButton data-testid={`${testId}`} {...rest} />;

  if (tooltip) {
    return (
      <Tooltip.Root>
        <Tooltip.Trigger data-testid={`${testId}-tooltip-trigger`} asChild>
          {buttonElement}
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side={side}
            data-testid={`${testId}-tooltip-content`}
            className="relative z-50 bg-gray-900 text-white text-xs px-2 py-1 rounded shadow-lg"
          >
            {tooltip}
            <Tooltip.Arrow className="fill-gray-900" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    );
  }

  return buttonElement;
}

export default Button;
